"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/*
 * Jira Ticket:
 * Created Date: Mon, 13th Jan 2020, 12:19:42 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */
var pageStyles = function pageStyles() {
  return {
    main: {
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100vh',
      height: '1px',
      alignItems: 'center',
      justifyContent: 'flex-start',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
      backgroundColor: 'rgb(225, 225, 225)'
    },
    card: {
      minWidth: 450,
      marginTop: '6em'
    },
    avatar: {
      margin: '1em',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%'
    },
    icon: {
      backgroundColor: 'rgb(143, 143, 143)',
      width: 50,
      height: 50,
      marginTop: '5%'
    }
  };
};

var _default = pageStyles;
exports.default = _default;